module.exports = __webpack_public_path__ + "static/img/aa3.3500d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/202104/aa3.png
// module id = gRhB
// module chunks = 0